import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import { useStore } from '../../../../../store/store-provider';
import ActionButton from '../../../../shared/action-button/action-button';
import './activity-filters-nav.scss';
import { AttendeeStatus } from '../../../../../constans/attendee-enums';

interface IAttendeeFilterButton {
    title: string;
    isActive: boolean;
    onSelect: () => void;
    id: string;
    attendeeActivityNumber: number;
    enabled: boolean;
}

const ActivityFiltersNav: FC = () => {
  const { attendeesStore, permissionsStore } = useStore();
  const { isPodiumDisconnectEnabled } = permissionsStore;
  const { getAttendeesService, setIsLoading } = attendeesStore;
  const { activityFilters, getActivityAttendeeCountService, selectActivityFilter } = getAttendeesService();
  const { activeAttendeeNumber, departureAttendeeNumber, disconnectedAttendeeNumber } = getActivityAttendeeCountService();

  const attendeeFilterButtons: IAttendeeFilterButton[] = [
    {
      id: 'active-button',
      title: 'Active',
      isActive: activityFilters.includes(AttendeeStatus.ACTIVE),
      onSelect: () => {
        setIsLoading(true);
        selectActivityFilter(AttendeeStatus.ACTIVE);
      },
      attendeeActivityNumber: activeAttendeeNumber,
      enabled: true,
    },
    {
      id: 'departures-button',
      title: 'Departures',
      isActive: activityFilters.includes(AttendeeStatus.DEPARTED),
      onSelect: () => {
        setIsLoading(true);
        selectActivityFilter(AttendeeStatus.DEPARTED);
      },
      attendeeActivityNumber: departureAttendeeNumber,
      enabled: true
    },
    {
      id: 'disconnected-button',
      title: 'Disconnected',
      isActive: activityFilters.includes(AttendeeStatus.DISCONNECTED),
      onSelect: () => {
        setIsLoading(true);
        selectActivityFilter([AttendeeStatus.DISCONNECTED, AttendeeStatus.DISCONNECTING]);
      },
      attendeeActivityNumber: disconnectedAttendeeNumber,
      enabled: !!isPodiumDisconnectEnabled()
    }
  ];

  return (
    <div className='attendee-activity-filters-nav'>
      <span className='attendee-activity-filters-nav_title'>Filters:</span>
      <div className='attendee-activity-filters-nav_button-group'>
        {attendeeFilterButtons.map((filterButton: IAttendeeFilterButton) => (
          <React.Fragment key={filterButton.id}>
            {filterButton.enabled && (
              <ActionButton
                customClasses={classNames('attendee-activity-filter-button', {
                  'isActiveFilter': filterButton.isActive
                })}
                onClick={filterButton.onSelect}
              >
                <span>{filterButton.title}</span>({filterButton.attendeeActivityNumber})
              </ActionButton>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default observer(ActivityFiltersNav);